import { withSvgIcon } from './withSvgIcon';

export const MetaMaskWallet = withSvgIcon(
  <>
    <path
      d="M18.9268 2.45093L12.0562 7.55388L13.3267 4.54321L18.9268 2.45093Z"
      fill="#E2761B"
      stroke="#E2761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.06592 2.45093L9.88136 7.60221L8.67295 4.54321L3.06592 2.45093Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4549 14.2798L14.625 17.0833L18.5403 18.1605L19.6658 14.3419L16.4549 14.2798Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.34082 14.3419L3.45946 18.1605L7.37472 17.0833L5.54484 14.2798L2.34082 14.3419Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.15401 9.54291L6.06299 11.1933L9.95062 11.3659L9.81252 7.18823L7.15401 9.54291Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8394 9.54462L12.1464 7.1416L12.0566 11.3676L15.9374 11.195L14.8394 9.54462Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.37451 17.0814L9.70847 15.9421L7.69215 14.3677L7.37451 17.0814Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2847 15.9421L14.6255 17.0814L14.301 14.3677L12.2847 15.9421Z"
      fill="#E4761B"
      stroke="#E4761B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.625 17.0825L12.2842 15.9431L12.4706 17.4692L12.4499 18.1113L14.625 17.0825Z"
      fill="#D7C1B3"
      stroke="#D7C1B3"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.37451 17.0822L9.54965 18.1111L9.53584 17.4689L9.70847 15.9429L7.37451 17.0822Z"
      fill="#D7C1B3"
      stroke="#D7C1B3"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58448 13.3617L7.63721 12.7885L9.01134 12.1602L9.58448 13.3617Z"
      fill="#233447"
      stroke="#233447"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4082 13.3617L12.9813 12.1602L14.3624 12.7885L12.4082 13.3617Z"
      fill="#233447"
      stroke="#233447"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.37431 17.0835L7.70576 14.28L5.54443 14.3422L7.37431 17.0835Z"
      fill="#CD6116"
      stroke="#CD6116"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2935 14.28L14.6249 17.0835L16.4548 14.3422L14.2935 14.28Z"
      fill="#CD6116"
      stroke="#CD6116"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9369 11.1934L12.0562 11.366L12.4152 13.3616L12.9884 12.1601L14.3694 12.7885L15.9369 11.1934Z"
      fill="#CD6116"
      stroke="#CD6116"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.63689 12.7885L9.01793 12.1601L9.58416 13.3616L9.95013 11.366L6.0625 11.1934L7.63689 12.7885Z"
      fill="#CD6116"
      stroke="#CD6116"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.06299 11.1934L7.69262 14.3698L7.63738 12.7885L6.06299 11.1934Z"
      fill="#E4751F"
      stroke="#E4751F"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3698 12.7885L14.3008 14.3698L15.9373 11.1934L14.3698 12.7885Z"
      fill="#E4751F"
      stroke="#E4751F"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.95094 11.3652L9.58496 13.3608L10.0407 15.7155L10.1443 12.6151L9.95094 11.3652Z"
      fill="#E4751F"
      stroke="#E4751F"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.057 11.3652L11.8706 12.6082L11.9535 15.7155L12.4161 13.3608L12.057 11.3652Z"
      fill="#E4751F"
      stroke="#E4751F"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4158 13.36L11.9531 15.7147L12.2846 15.9425L14.3009 14.3682L14.3699 12.7869L12.4158 13.36Z"
      fill="#F6851B"
      stroke="#F6851B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.63721 12.7869L7.69245 14.3682L9.70877 15.9425L10.0402 15.7147L9.58448 13.36L7.63721 12.7869Z"
      fill="#F6851B"
      stroke="#F6851B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4498 18.1126L12.4706 17.4704L12.2979 17.3185H9.69466L9.53584 17.4704L9.54965 18.1126L7.37451 17.0837L8.13409 17.7052L9.67395 18.7755H12.3186L13.8654 17.7052L14.625 17.0837L12.4498 18.1126Z"
      fill="#C0AD9E"
      stroke="#C0AD9E"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2844 15.9437L11.953 15.7158H10.0402L9.70876 15.9437L9.53613 17.4697L9.69495 17.3178H12.2982L12.4708 17.4697L12.2844 15.9437Z"
      fill="#161616"
      stroke="#161616"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.218 7.88533L19.8049 5.068L18.928 2.45093L12.2852 7.38125L14.8401 9.54258L18.4515 10.5991L19.2525 9.66687L18.9073 9.41828L19.4597 8.9142L19.0315 8.58275L19.584 8.16154L19.218 7.88533Z"
      fill="#763D16"
      stroke="#763D16"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.19629 5.06776L2.78323 7.88508L2.41035 8.16129L2.96277 8.58251L2.54155 8.91396L3.09397 9.41804L2.74871 9.66663L3.5428 10.5988L7.15423 9.54233L9.70916 7.381L3.06635 2.45068L2.19629 5.06776Z"
      fill="#763D16"
      stroke="#763D16"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4508 10.5992L14.8394 9.54272L15.9373 11.1931L14.3008 14.3695L16.4552 14.3418H19.6661L18.4508 10.5992Z"
      fill="#F6851B"
      stroke="#F6851B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.15375 9.54272L3.54233 10.5992L2.34082 14.3418H5.54484L7.69236 14.3695L6.06273 11.1931L7.15375 9.54272Z"
      fill="#F6851B"
      stroke="#F6851B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0569 11.3663L12.2848 7.38199L13.3344 4.54395H8.67334L9.70912 7.38199L9.9508 11.3663L10.0337 12.623L10.0406 15.7166H11.9533L11.9671 12.623L12.0569 11.3663Z"
      fill="#F6851B"
      stroke="#F6851B"
      strokeWidth="0.0517891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 22 22' },
);
